import { ModuleContent } from '../contract';

export type CookieButtonModuleContent = {
	buttonText: string;
	isRejectButton: boolean;
};

export function isCookieButtonModuleContent(content: ModuleContent): content is CookieButtonModuleContent {
	const cookieButtonContent = content as Partial<CookieButtonModuleContent>;
	return typeof cookieButtonContent.buttonText === 'string' && typeof cookieButtonContent.isRejectButton === 'boolean';
}

export function getCookieButtonModuleIndexableText(content: ModuleContent): string {
	if (!isCookieButtonModuleContent(content)) return '';
	return content.buttonText.trim();
}